module.exports = __webpack_public_path__ + "static/img/101846.98b61c84.png";